import React, { useEffect, useState } from 'react';
import { Polyline } from 'react-leaflet';
import api from '../../api/client';

interface TripPoint {
  lat: number;
  lon: number;
}

interface TripSegment {
  type: 'trasa' | 'zatrzymanie' | 'postoj';
  points: TripPoint[];
}

interface Props {
  deviceId: string | null;
}

export default function TodayTrail({ deviceId }: Props) {
  const [routes, setRoutes] = useState<TripPoint[][]>([]);

  useEffect(() => {
    if (!deviceId) { setRoutes([]); return; }

    const fetchTrail = () => {
      const today = new Date().toISOString().slice(0, 10);
      api.get(`/devices/${deviceId}/trips`, { params: { date: today } })
        .then((r) => {
          const segments = r.data as TripSegment[];
          setRoutes(segments.filter((s) => s.type === 'trasa' && s.points.length > 1).map((s) => s.points));
        })
        .catch(() => setRoutes([]));
    };

    fetchTrail();
    const interval = setInterval(fetchTrail, 60000);
    return () => clearInterval(interval);
  }, [deviceId]);

  return (
    <>
      {routes.map((points, i) => (
        <Polyline
          key={i}
          positions={points.map((p) => [p.lat, p.lon])}
          pathOptions={{ color: '#1d4ed8', weight: 4, opacity: 0.7 }}
        />
      ))}
    </>
  );
}
